
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AccountEvent": [
      "UpdateAccountPayload"
    ],
    "AccountSubscriptionEvent": [
      "UpdateAccountSubscriptionPayload"
    ],
    "AccountUserExportEvent": [
      "CreateAccountUserExportPayload"
    ],
    "AccountUserGroupEvent": [
      "SyncAdobeGroupMembersPayload"
    ],
    "AcpAsset": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "FolderAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VersionStackAsset",
      "VideoAsset"
    ],
    "AdvancedSearchResult": [
      "AssetResult",
      "ProjectResult"
    ],
    "ApprovalEvent": [
      "LockApprovalPayload"
    ],
    "Asset": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "FolderAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VersionStackAsset",
      "VideoAsset"
    ],
    "AssetAggregate": [
      "AdHocAssetsShare",
      "Collection",
      "CollectionShare"
    ],
    "AssetAggregateField": [
      "CollectionField",
      "ShareField"
    ],
    "AssetAggregateFieldConnection": [
      "CollectionFieldConnection",
      "ShareFieldConnection"
    ],
    "AssetApprover": [
      "AccountUser"
    ],
    "AssetFieldValueEvent": [
      "SetAssetFieldValuePayload",
      "StartUpdateAssetFieldValuesOperationPayload",
      "UpdateAssetFieldValuesPayload"
    ],
    "AssetJob": [
      "BrandValidationAssetJob",
      "GenericAssetJob"
    ],
    "AssetJobEvent": [
      "CreateAssetJobPayload",
      "UpdateAssetJobPayload"
    ],
    "AssetOperation": [
      "CopyAssetsOperation",
      "DeleteAssetsOperation",
      "HardDeleteAssetsOperation",
      "MoveAssetsOperation",
      "UpdateAssetFieldValuesOperation"
    ],
    "AssetOperationEvent": [
      "CompleteAssetOperationPayload",
      "CreateAssetOperationPayload",
      "StartCopyAssetsOperationPayload",
      "StartDeleteAssetsOperationPayload",
      "StartMoveAssetsOperationPayload"
    ],
    "AssetResultMatch": [
      "AssigneeMatch",
      "AudioSampleRateMatch",
      "BitDepthMatch",
      "BitRateMatch",
      "ChannelsMatch",
      "CodecMatch",
      "ColorSpaceMatch",
      "CommentCountMatch",
      "CommentMatch",
      "CreatorMatch",
      "DeletedAtMatch",
      "DurationMatch",
      "DynamicRangeMatch",
      "FileTypeMatch",
      "FilesizeMatch",
      "FormatMatch",
      "FrameRateMatch",
      "HasAlphaChannelMatch",
      "InsertedAtMatch",
      "KeywordsMatch",
      "NameMatch",
      "NotesMatch",
      "PageCountMatch",
      "ProjectMatch",
      "RatingMatch",
      "ResolutionHeightMatch",
      "ResolutionWidthMatch",
      "SourceFilenameMatch",
      "StatusMatch",
      "TranscriptionMatch",
      "UpdatedAtMatch",
      "UploadedAtMatch",
      "VisualMatch"
    ],
    "AssetsEvent": [
      "AddAssetTreeToTransferBatchPayload",
      "AddAssetsToTransferBatchPayload",
      "CreateAssetPayload",
      "CreateFolderPayload",
      "CreateFolderTreePayload",
      "DeleteAssetPayload",
      "DeleteAssetsPayload",
      "DuplicateAssetPayload",
      "DuplicateAssetsPayload",
      "MoveAssetPayload",
      "MoveAssetsPayload",
      "RenameAssetPayload",
      "RestoreAssetsPayload",
      "StartCopyAssetsOperationPayload",
      "StartDeleteAssetsOperationPayload",
      "StartMoveAssetsOperationPayload",
      "UpdateAssetPayload",
      "UpdateAssetWithFramesPayload",
      "UpdateAssetsPayload",
      "VersionStackCreatedPayload",
      "VersionStackUnversionPayload",
      "VersionStackUpdateTopPayload"
    ],
    "Collectible": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VideoAsset"
    ],
    "CollectionEvent": [
      "UpdateCollectionPayload"
    ],
    "CommentEntity": [
      "CommentHashtag",
      "CommentLink",
      "CommentMention"
    ],
    "CommentEvent": [
      "AddCommentReactionPayload",
      "CreateCommentPayload",
      "DeleteCommentPayload",
      "MarkCommentAsCompletePayload",
      "MarkCommentAsIncompletePayload",
      "MarkCommentAsReadPayload",
      "RemoveCommentReactionPayload",
      "ReplyToCommentPayload",
      "UpdateCommentPayload"
    ],
    "CommentExportEvent": [
      "CreateCommentExportPayload"
    ],
    "ContainerAsset": [
      "FolderAsset",
      "VersionStackAsset"
    ],
    "DeviceAuthorizationGrantClient": [
      "DeviceAuthorizationGrantC2cClient"
    ],
    "DeviceLinkEvent": [
      "AddDeviceLinkChannelPayload",
      "AddDeviceLinkPayload",
      "PauseDeviceLinksPayload",
      "ResumeDeviceLinksPayload",
      "RevokeDeviceLinkAuthorizationsPayload",
      "RevokeDeviceLinkChannelPayload",
      "UpdateDeviceLinkChannelInputPayload",
      "UpdateDeviceLinkChannelPayload",
      "UpdateDeviceLinkPayload"
    ],
    "ExportRenderEventsPayload": [
      "RenderJobCompletePayload",
      "RenderJobFailedPayload",
      "RenderJobStartedPayload"
    ],
    "ExportsXMPMetadata": [
      "SequenceExportsXMPMetadata",
      "V3PanelExportsXMPMetadata",
      "V4CommentsPanelExportsXMPMetadata"
    ],
    "ExternallyManagedUserGroup": [
      "AdobeManagedUserGroup",
      "WorkfrontManagedUserGroup"
    ],
    "FieldDefinitionConfiguration": [
      "DateFieldConfiguration",
      "NumberFieldConfiguration",
      "RatingFieldConfiguration",
      "SelectFieldConfiguration",
      "ToggleFieldConfiguration",
      "UserFieldConfiguration",
      "UsersFieldConfiguration"
    ],
    "FieldDefinitionScope": [
      "Account",
      "Project",
      "Workspace"
    ],
    "FieldValue": [
      "DateFieldValue",
      "DerivedFieldValue",
      "JsonFieldValue",
      "LinkFieldValue",
      "LongTextFieldValue",
      "NumberFieldValue",
      "RatingFieldValue",
      "SelectFieldValue",
      "SelectMultiFieldValue",
      "TextFieldValue",
      "ToggleFieldValue",
      "UrlFieldValue",
      "UserMultiFieldValue",
      "UserSingleFieldValue",
      "UsersFieldValue"
    ],
    "FioVersionMigrationStatus": [
      "FioVersionMigrationBlocked",
      "FioVersionMigrationEligible",
      "FioVersionMigrationFailed",
      "FioVersionMigrationInProgress",
      "FioVersionMigrationIneligible",
      "FioVersionMigrationMigrated",
      "FioVersionMigrationMustMigrate",
      "FioVersionMigrationPending",
      "FioVersionMigrationRollingBack",
      "FioVersionMigrationStatusUnknown"
    ],
    "FireflyGenerationEvent": [
      "UpdateFireflyGenerationStatusPayload"
    ],
    "FireflySize": [
      "FireflyFixedSizes",
      "FireflySizeRange"
    ],
    "FolderEvent": [
      "UpdateFolderStatsPayload"
    ],
    "FolderThumbnailItem": [
      "FolderThumbnailFileItem",
      "FolderThumbnailFolderItem"
    ],
    "FormField": [
      "BooleanField",
      "SelectField",
      "TextField"
    ],
    "ImportEventsPayload": [
      "DownloadJobProgressPayload",
      "ImportCanceledPayload",
      "ImportCompletePayload"
    ],
    "InboxEvent": [
      "InboxUnopenedCountUpdatePayload"
    ],
    "InteractionEvent": [
      "InteractionResponsePayload"
    ],
    "InvoiceItem": [
      "LineItem",
      "Plan"
    ],
    "Media": [
      "AudioMedia",
      "DocumentMedia",
      "ImageMedia",
      "InteractiveLiveMedia",
      "InteractiveMedia",
      "ModelMedia",
      "UnsupportedMedia",
      "VideoMedia"
    ],
    "MediaEvent": [
      "UpdateMediaPayload"
    ],
    "MediaTranscode": [
      "AudioTranscodeInfo",
      "ImageTranscodeInfo",
      "InteractiveTranscodeInfo",
      "ModelTranscodeInfo",
      "PdfDownloadInfo",
      "PdfProxyTranscodeInfo",
      "ThumbTranscodeInfo",
      "VideoTranscode",
      "VideoTranscodeInfo",
      "WaveformPreviewTranscodeInfo"
    ],
    "MountedAsset": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VideoAsset"
    ],
    "MutationPayload": [
      "DeleteTransferBatchesPayload",
      "StoreMostRecentSearchResultPayload",
      "UpdateTransferBatchAssetItemsPayload",
      "UpdateTransferBatchesPayload"
    ],
    "NotificationGroup": [
      "NotificationGroupAccessRequestApproved",
      "NotificationGroupAccessRequestDenied",
      "NotificationGroupAccessRequestSubmitted",
      "NotificationGroupAssetAssignedToYou",
      "NotificationGroupAssetStatusChanged",
      "NotificationGroupCommentCreated",
      "NotificationGroupCommentCreatedShareAccess",
      "NotificationGroupFileUploaded",
      "NotificationGroupReplyCreated",
      "NotificationGroupReplyCreatedShareAccess",
      "NotificationGroupRequesterAccessRequestApproved",
      "NotificationGroupRequesterAccessRequestDenied",
      "NotificationGroupTranscriptCompletedSelf",
      "NotificationGroupTransferBatchCompleted",
      "NotificationGroupTransferBatchCompletedSelf",
      "NotificationGroupUserMentioned",
      "NotificationGroupUserMentionedShareAccess"
    ],
    "NotificationGroupEvent": [
      "NotificationGroupUnopenedCountUpdatePayload"
    ],
    "NotificationLayoutItem": [
      "NotificationLayoutItemAssetName",
      "NotificationLayoutItemChip",
      "NotificationLayoutItemProjectName",
      "NotificationLayoutItemSection",
      "NotificationLayoutItemShareName",
      "NotificationLayoutItemText",
      "NotificationLayoutItemTimestamp",
      "NotificationLayoutItemUserName"
    ],
    "NotificationLayoutItemStyle": [
      "NotificationLayoutItemStyleChip",
      "NotificationLayoutItemStyleSection",
      "NotificationLayoutItemStyleText"
    ],
    "NotificationLink": [
      "NotificationLinkAccessRequestAsset",
      "NotificationLinkAccessRequestCollection",
      "NotificationLinkAccessRequestFolder",
      "NotificationLinkAccessRequestProject",
      "NotificationLinkAsset",
      "NotificationLinkComment",
      "NotificationLinkCommentViaShare",
      "NotificationLinkFolder"
    ],
    "NotificationTypeSetting": [
      "NotificationTypeSettingAccessRequestApproved",
      "NotificationTypeSettingAccessRequestDenied",
      "NotificationTypeSettingAccessRequestSubmitted",
      "NotificationTypeSettingAccountDelinquent",
      "NotificationTypeSettingAssetAssignedToYou",
      "NotificationTypeSettingAssetStatusChanged",
      "NotificationTypeSettingCommentCreated",
      "NotificationTypeSettingReplyCreated",
      "NotificationTypeSettingRequesterAccessRequestApproved",
      "NotificationTypeSettingRequesterAccessRequestDenied",
      "NotificationTypeSettingTranscriptCompletedSelf",
      "NotificationTypeSettingTransferBatchCompleted",
      "NotificationTypeSettingTransferBatchCompletedSelf",
      "NotificationTypeSettingUserMentioned"
    ],
    "PaymentMethod": [
      "PaymentCard",
      "PaymentCheck"
    ],
    "PremiereProjectEventsPayload": [
      "PremiereProjectClosedPayload",
      "PremiereProjectOpenedPayload"
    ],
    "ProjectEvent": [
      "CreateProjectPayload",
      "DeleteProjectPayload",
      "UpdateProjectPayload"
    ],
    "ProjectExportEvent": [
      "CreateProjectExportPayload"
    ],
    "ProjectResultMatch": [
      "NameMatch"
    ],
    "QuickSearchNlpResult": [
      "AssetResult",
      "ProjectResult"
    ],
    "QuickSearchResult": [
      "AssetResult",
      "ProjectResult"
    ],
    "ReportAbuseCategory": [
      "RedirectReportAbuseCategory",
      "StandardReportAbuseCategory"
    ],
    "RequestedResource": [
      "Collection",
      "FileAsset",
      "FolderAsset",
      "Project",
      "VersionStackAsset"
    ],
    "Resource": [
      "Account",
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "FolderAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "Project",
      "UnsupportedAsset",
      "VersionStackAsset",
      "VideoAsset",
      "Workspace"
    ],
    "ResourceAccessInfo": [
      "AccessRequest",
      "AccessRequestUnavailable",
      "PredictedAccessRequestUsage"
    ],
    "ResourceControlPolicyEvent": [
      "UpdateResourceControlPoliciesPayload"
    ],
    "ResourceSearchResult": [
      "Project",
      "Workspace"
    ],
    "ResponseBody": [
      "FormCallback",
      "MessageCallback"
    ],
    "SelectMemberValue": [
      "AccountUserGroupSelectMemberValue",
      "UserSelectMemberValue"
    ],
    "SequenceEventsPayload": [
      "SequenceActivatedPayload",
      "SequenceClosedPayload",
      "SequenceEncodeCanceledPayload",
      "SequenceEncodeCompletePayload",
      "SequenceEncodeProgressErrorPayload",
      "SequenceEncodeProgressPayload",
      "SequenceUploadJobItemProgressPayload",
      "SequenceUploadJobProgressPayload"
    ],
    "Share": [
      "AdHocAssetsShare",
      "CollectionShare"
    ],
    "ShareEvent": [
      "CreateShareEventPayload"
    ],
    "ShareListMembership": [
      "AccountUser",
      "ShareListEmailMember"
    ],
    "StorageOverageReportExportEvent": [
      "CreateStorageOverageReportExportPayload"
    ],
    "SuggestedMember": [
      "SuggestedAccountUser",
      "SuggestedAccountUserGroup",
      "SuggestedShareList"
    ],
    "ThumbScrubSprite": [
      "ThumbScrubSheet",
      "ThumbScrubStrip"
    ],
    "Timezone": [
      "AliasTimezone",
      "CanonicalTimezone"
    ],
    "TranscriptionEvent": [
      "CreateTranscriptionPayload",
      "DeleteTranscriptionPayload",
      "EditTranscriptionPayload",
      "UpdateTranscriptionPayload"
    ],
    "TransferBatchEvent": [
      "AddAssetTreeToTransferBatchPayload",
      "AddAssetsToTransferBatchPayload",
      "UpdateTransferBatchPayload"
    ],
    "UndoRedoCommandInputValues": [
      "SetAssetFieldValueInputValues"
    ],
    "UploadJobEventsPayload": [
      "UploadJobItemProgressPayload",
      "UploadJobProgressPayload"
    ],
    "UpsertAccountUserChange": [
      "AccountUserAdded",
      "AccountUserModified",
      "AccountUserNoop"
    ],
    "User": [
      "AuthenticatedUser",
      "IdentifiedUser"
    ],
    "UserGroup": [
      "AdobeManagedUserGroup",
      "FrameManagedUserGroup",
      "WorkfrontManagedUserGroup"
    ],
    "WatermarkDataPoint": [
      "WatermarkDataPointCustomText",
      "WatermarkDataPointEmail",
      "WatermarkDataPointIpAddress",
      "WatermarkDataPointTimestamp",
      "WatermarkDataPointUserInput",
      "WatermarkDataPointUserName"
    ],
    "WorkspaceExportEvent": [
      "CreateWorkspaceExportPayload"
    ],
    "WorkspaceUsageReportExportEvent": [
      "CreateWorkspaceUsageReportExportPayload"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccountEvent": [
      "UpdateAccountPayload"
    ],
    "AccountSubscriptionEvent": [
      "UpdateAccountSubscriptionPayload"
    ],
    "AccountUserExportEvent": [
      "CreateAccountUserExportPayload"
    ],
    "AccountUserGroupEvent": [
      "SyncAdobeGroupMembersPayload"
    ],
    "AcpAsset": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "FolderAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VersionStackAsset",
      "VideoAsset"
    ],
    "AdvancedSearchResult": [
      "AssetResult",
      "ProjectResult"
    ],
    "ApprovalEvent": [
      "LockApprovalPayload"
    ],
    "Asset": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "FolderAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VersionStackAsset",
      "VideoAsset"
    ],
    "AssetAggregate": [
      "AdHocAssetsShare",
      "Collection",
      "CollectionShare"
    ],
    "AssetAggregateField": [
      "CollectionField",
      "ShareField"
    ],
    "AssetAggregateFieldConnection": [
      "CollectionFieldConnection",
      "ShareFieldConnection"
    ],
    "AssetApprover": [
      "AccountUser"
    ],
    "AssetFieldValueEvent": [
      "SetAssetFieldValuePayload",
      "StartUpdateAssetFieldValuesOperationPayload",
      "UpdateAssetFieldValuesPayload"
    ],
    "AssetJob": [
      "BrandValidationAssetJob",
      "GenericAssetJob"
    ],
    "AssetJobEvent": [
      "CreateAssetJobPayload",
      "UpdateAssetJobPayload"
    ],
    "AssetOperation": [
      "CopyAssetsOperation",
      "DeleteAssetsOperation",
      "HardDeleteAssetsOperation",
      "MoveAssetsOperation",
      "UpdateAssetFieldValuesOperation"
    ],
    "AssetOperationEvent": [
      "CompleteAssetOperationPayload",
      "CreateAssetOperationPayload",
      "StartCopyAssetsOperationPayload",
      "StartDeleteAssetsOperationPayload",
      "StartMoveAssetsOperationPayload"
    ],
    "AssetResultMatch": [
      "AssigneeMatch",
      "AudioSampleRateMatch",
      "BitDepthMatch",
      "BitRateMatch",
      "ChannelsMatch",
      "CodecMatch",
      "ColorSpaceMatch",
      "CommentCountMatch",
      "CommentMatch",
      "CreatorMatch",
      "DeletedAtMatch",
      "DurationMatch",
      "DynamicRangeMatch",
      "FileTypeMatch",
      "FilesizeMatch",
      "FormatMatch",
      "FrameRateMatch",
      "HasAlphaChannelMatch",
      "InsertedAtMatch",
      "KeywordsMatch",
      "NameMatch",
      "NotesMatch",
      "PageCountMatch",
      "ProjectMatch",
      "RatingMatch",
      "ResolutionHeightMatch",
      "ResolutionWidthMatch",
      "SourceFilenameMatch",
      "StatusMatch",
      "TranscriptionMatch",
      "UpdatedAtMatch",
      "UploadedAtMatch",
      "VisualMatch"
    ],
    "AssetsEvent": [
      "AddAssetTreeToTransferBatchPayload",
      "AddAssetsToTransferBatchPayload",
      "CreateAssetPayload",
      "CreateFolderPayload",
      "CreateFolderTreePayload",
      "DeleteAssetPayload",
      "DeleteAssetsPayload",
      "DuplicateAssetPayload",
      "DuplicateAssetsPayload",
      "MoveAssetPayload",
      "MoveAssetsPayload",
      "RenameAssetPayload",
      "RestoreAssetsPayload",
      "StartCopyAssetsOperationPayload",
      "StartDeleteAssetsOperationPayload",
      "StartMoveAssetsOperationPayload",
      "UpdateAssetPayload",
      "UpdateAssetWithFramesPayload",
      "UpdateAssetsPayload",
      "VersionStackCreatedPayload",
      "VersionStackUnversionPayload",
      "VersionStackUpdateTopPayload"
    ],
    "Collectible": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VideoAsset"
    ],
    "CollectionEvent": [
      "UpdateCollectionPayload"
    ],
    "CommentEntity": [
      "CommentHashtag",
      "CommentLink",
      "CommentMention"
    ],
    "CommentEvent": [
      "AddCommentReactionPayload",
      "CreateCommentPayload",
      "DeleteCommentPayload",
      "MarkCommentAsCompletePayload",
      "MarkCommentAsIncompletePayload",
      "MarkCommentAsReadPayload",
      "RemoveCommentReactionPayload",
      "ReplyToCommentPayload",
      "UpdateCommentPayload"
    ],
    "CommentExportEvent": [
      "CreateCommentExportPayload"
    ],
    "ContainerAsset": [
      "FolderAsset",
      "VersionStackAsset"
    ],
    "DeviceAuthorizationGrantClient": [
      "DeviceAuthorizationGrantC2cClient"
    ],
    "DeviceLinkEvent": [
      "AddDeviceLinkChannelPayload",
      "AddDeviceLinkPayload",
      "PauseDeviceLinksPayload",
      "ResumeDeviceLinksPayload",
      "RevokeDeviceLinkAuthorizationsPayload",
      "RevokeDeviceLinkChannelPayload",
      "UpdateDeviceLinkChannelInputPayload",
      "UpdateDeviceLinkChannelPayload",
      "UpdateDeviceLinkPayload"
    ],
    "ExportRenderEventsPayload": [
      "RenderJobCompletePayload",
      "RenderJobFailedPayload",
      "RenderJobStartedPayload"
    ],
    "ExportsXMPMetadata": [
      "SequenceExportsXMPMetadata",
      "V3PanelExportsXMPMetadata",
      "V4CommentsPanelExportsXMPMetadata"
    ],
    "ExternallyManagedUserGroup": [
      "AdobeManagedUserGroup",
      "WorkfrontManagedUserGroup"
    ],
    "FieldDefinitionConfiguration": [
      "DateFieldConfiguration",
      "NumberFieldConfiguration",
      "RatingFieldConfiguration",
      "SelectFieldConfiguration",
      "ToggleFieldConfiguration",
      "UserFieldConfiguration",
      "UsersFieldConfiguration"
    ],
    "FieldDefinitionScope": [
      "Account",
      "Project",
      "Workspace"
    ],
    "FieldValue": [
      "DateFieldValue",
      "DerivedFieldValue",
      "JsonFieldValue",
      "LinkFieldValue",
      "LongTextFieldValue",
      "NumberFieldValue",
      "RatingFieldValue",
      "SelectFieldValue",
      "SelectMultiFieldValue",
      "TextFieldValue",
      "ToggleFieldValue",
      "UrlFieldValue",
      "UserMultiFieldValue",
      "UserSingleFieldValue",
      "UsersFieldValue"
    ],
    "FioVersionMigrationStatus": [
      "FioVersionMigrationBlocked",
      "FioVersionMigrationEligible",
      "FioVersionMigrationFailed",
      "FioVersionMigrationInProgress",
      "FioVersionMigrationIneligible",
      "FioVersionMigrationMigrated",
      "FioVersionMigrationMustMigrate",
      "FioVersionMigrationPending",
      "FioVersionMigrationRollingBack",
      "FioVersionMigrationStatusUnknown"
    ],
    "FireflyGenerationEvent": [
      "UpdateFireflyGenerationStatusPayload"
    ],
    "FireflySize": [
      "FireflyFixedSizes",
      "FireflySizeRange"
    ],
    "FolderEvent": [
      "UpdateFolderStatsPayload"
    ],
    "FolderThumbnailItem": [
      "FolderThumbnailFileItem",
      "FolderThumbnailFolderItem"
    ],
    "FormField": [
      "BooleanField",
      "SelectField",
      "TextField"
    ],
    "ImportEventsPayload": [
      "DownloadJobProgressPayload",
      "ImportCanceledPayload",
      "ImportCompletePayload"
    ],
    "InboxEvent": [
      "InboxUnopenedCountUpdatePayload"
    ],
    "InteractionEvent": [
      "InteractionResponsePayload"
    ],
    "InvoiceItem": [
      "LineItem",
      "Plan"
    ],
    "Media": [
      "AudioMedia",
      "DocumentMedia",
      "ImageMedia",
      "InteractiveLiveMedia",
      "InteractiveMedia",
      "ModelMedia",
      "UnsupportedMedia",
      "VideoMedia"
    ],
    "MediaEvent": [
      "UpdateMediaPayload"
    ],
    "MediaTranscode": [
      "AudioTranscodeInfo",
      "ImageTranscodeInfo",
      "InteractiveTranscodeInfo",
      "ModelTranscodeInfo",
      "PdfDownloadInfo",
      "PdfProxyTranscodeInfo",
      "ThumbTranscodeInfo",
      "VideoTranscode",
      "VideoTranscodeInfo",
      "WaveformPreviewTranscodeInfo"
    ],
    "MountedAsset": [
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "UnsupportedAsset",
      "VideoAsset"
    ],
    "MutationPayload": [
      "DeleteTransferBatchesPayload",
      "StoreMostRecentSearchResultPayload",
      "UpdateTransferBatchAssetItemsPayload",
      "UpdateTransferBatchesPayload"
    ],
    "NotificationGroup": [
      "NotificationGroupAccessRequestApproved",
      "NotificationGroupAccessRequestDenied",
      "NotificationGroupAccessRequestSubmitted",
      "NotificationGroupAssetAssignedToYou",
      "NotificationGroupAssetStatusChanged",
      "NotificationGroupCommentCreated",
      "NotificationGroupCommentCreatedShareAccess",
      "NotificationGroupFileUploaded",
      "NotificationGroupReplyCreated",
      "NotificationGroupReplyCreatedShareAccess",
      "NotificationGroupRequesterAccessRequestApproved",
      "NotificationGroupRequesterAccessRequestDenied",
      "NotificationGroupTranscriptCompletedSelf",
      "NotificationGroupTransferBatchCompleted",
      "NotificationGroupTransferBatchCompletedSelf",
      "NotificationGroupUserMentioned",
      "NotificationGroupUserMentionedShareAccess"
    ],
    "NotificationGroupEvent": [
      "NotificationGroupUnopenedCountUpdatePayload"
    ],
    "NotificationLayoutItem": [
      "NotificationLayoutItemAssetName",
      "NotificationLayoutItemChip",
      "NotificationLayoutItemProjectName",
      "NotificationLayoutItemSection",
      "NotificationLayoutItemShareName",
      "NotificationLayoutItemText",
      "NotificationLayoutItemTimestamp",
      "NotificationLayoutItemUserName"
    ],
    "NotificationLayoutItemStyle": [
      "NotificationLayoutItemStyleChip",
      "NotificationLayoutItemStyleSection",
      "NotificationLayoutItemStyleText"
    ],
    "NotificationLink": [
      "NotificationLinkAccessRequestAsset",
      "NotificationLinkAccessRequestCollection",
      "NotificationLinkAccessRequestFolder",
      "NotificationLinkAccessRequestProject",
      "NotificationLinkAsset",
      "NotificationLinkComment",
      "NotificationLinkCommentViaShare",
      "NotificationLinkFolder"
    ],
    "NotificationTypeSetting": [
      "NotificationTypeSettingAccessRequestApproved",
      "NotificationTypeSettingAccessRequestDenied",
      "NotificationTypeSettingAccessRequestSubmitted",
      "NotificationTypeSettingAccountDelinquent",
      "NotificationTypeSettingAssetAssignedToYou",
      "NotificationTypeSettingAssetStatusChanged",
      "NotificationTypeSettingCommentCreated",
      "NotificationTypeSettingReplyCreated",
      "NotificationTypeSettingRequesterAccessRequestApproved",
      "NotificationTypeSettingRequesterAccessRequestDenied",
      "NotificationTypeSettingTranscriptCompletedSelf",
      "NotificationTypeSettingTransferBatchCompleted",
      "NotificationTypeSettingTransferBatchCompletedSelf",
      "NotificationTypeSettingUserMentioned"
    ],
    "PaymentMethod": [
      "PaymentCard",
      "PaymentCheck"
    ],
    "PremiereProjectEventsPayload": [
      "PremiereProjectClosedPayload",
      "PremiereProjectOpenedPayload"
    ],
    "ProjectEvent": [
      "CreateProjectPayload",
      "DeleteProjectPayload",
      "UpdateProjectPayload"
    ],
    "ProjectExportEvent": [
      "CreateProjectExportPayload"
    ],
    "ProjectResultMatch": [
      "NameMatch"
    ],
    "QuickSearchNlpResult": [
      "AssetResult",
      "ProjectResult"
    ],
    "QuickSearchResult": [
      "AssetResult",
      "ProjectResult"
    ],
    "ReportAbuseCategory": [
      "RedirectReportAbuseCategory",
      "StandardReportAbuseCategory"
    ],
    "RequestedResource": [
      "Collection",
      "FileAsset",
      "FolderAsset",
      "Project",
      "VersionStackAsset"
    ],
    "Resource": [
      "Account",
      "AudioAsset",
      "DocumentAsset",
      "FileAsset",
      "FolderAsset",
      "ImageAsset",
      "InteractiveAsset",
      "InteractiveLiveAsset",
      "ModelAsset",
      "Project",
      "UnsupportedAsset",
      "VersionStackAsset",
      "VideoAsset",
      "Workspace"
    ],
    "ResourceAccessInfo": [
      "AccessRequest",
      "AccessRequestUnavailable",
      "PredictedAccessRequestUsage"
    ],
    "ResourceControlPolicyEvent": [
      "UpdateResourceControlPoliciesPayload"
    ],
    "ResourceSearchResult": [
      "Project",
      "Workspace"
    ],
    "ResponseBody": [
      "FormCallback",
      "MessageCallback"
    ],
    "SelectMemberValue": [
      "AccountUserGroupSelectMemberValue",
      "UserSelectMemberValue"
    ],
    "SequenceEventsPayload": [
      "SequenceActivatedPayload",
      "SequenceClosedPayload",
      "SequenceEncodeCanceledPayload",
      "SequenceEncodeCompletePayload",
      "SequenceEncodeProgressErrorPayload",
      "SequenceEncodeProgressPayload",
      "SequenceUploadJobItemProgressPayload",
      "SequenceUploadJobProgressPayload"
    ],
    "Share": [
      "AdHocAssetsShare",
      "CollectionShare"
    ],
    "ShareEvent": [
      "CreateShareEventPayload"
    ],
    "ShareListMembership": [
      "AccountUser",
      "ShareListEmailMember"
    ],
    "StorageOverageReportExportEvent": [
      "CreateStorageOverageReportExportPayload"
    ],
    "SuggestedMember": [
      "SuggestedAccountUser",
      "SuggestedAccountUserGroup",
      "SuggestedShareList"
    ],
    "ThumbScrubSprite": [
      "ThumbScrubSheet",
      "ThumbScrubStrip"
    ],
    "Timezone": [
      "AliasTimezone",
      "CanonicalTimezone"
    ],
    "TranscriptionEvent": [
      "CreateTranscriptionPayload",
      "DeleteTranscriptionPayload",
      "EditTranscriptionPayload",
      "UpdateTranscriptionPayload"
    ],
    "TransferBatchEvent": [
      "AddAssetTreeToTransferBatchPayload",
      "AddAssetsToTransferBatchPayload",
      "UpdateTransferBatchPayload"
    ],
    "UndoRedoCommandInputValues": [
      "SetAssetFieldValueInputValues"
    ],
    "UploadJobEventsPayload": [
      "UploadJobItemProgressPayload",
      "UploadJobProgressPayload"
    ],
    "UpsertAccountUserChange": [
      "AccountUserAdded",
      "AccountUserModified",
      "AccountUserNoop"
    ],
    "User": [
      "AuthenticatedUser",
      "IdentifiedUser"
    ],
    "UserGroup": [
      "AdobeManagedUserGroup",
      "FrameManagedUserGroup",
      "WorkfrontManagedUserGroup"
    ],
    "WatermarkDataPoint": [
      "WatermarkDataPointCustomText",
      "WatermarkDataPointEmail",
      "WatermarkDataPointIpAddress",
      "WatermarkDataPointTimestamp",
      "WatermarkDataPointUserInput",
      "WatermarkDataPointUserName"
    ],
    "WorkspaceExportEvent": [
      "CreateWorkspaceExportPayload"
    ],
    "WorkspaceUsageReportExportEvent": [
      "CreateWorkspaceUsageReportExportPayload"
    ]
  }
};
      export default result;
    